export const CHAT_SCROLL_BOTTOM_THRESHOLD_PX = 96;

/** Scroll the transcript to the bottom (includes container padding). */
export function scrollChatToBottom(scrollContainer: HTMLElement, behavior: ScrollBehavior = "smooth"): void {
  scrollContainer.scrollTo({
    top: scrollContainer.scrollHeight,
    behavior
  });
}

export function distanceFromScrollBottom(scrollContainer: HTMLElement): number {
  return scrollContainer.scrollHeight - scrollContainer.scrollTop - scrollContainer.clientHeight;
}

/** Scroll so a message's top aligns with the chat viewport top when possible. */
export function scrollChatToMessage(
  scrollContainer: HTMLElement,
  messageEl: HTMLElement,
  behavior: ScrollBehavior = "smooth"
): void {
  const maxScroll = Math.max(0, scrollContainer.scrollHeight - scrollContainer.clientHeight);
  const styles = window.getComputedStyle(scrollContainer);
  const paddingTop = Number.parseFloat(styles.paddingTop) || 0;
  const paddingBottom = Number.parseFloat(styles.paddingBottom) || 0;
  const viewportHeight = scrollContainer.clientHeight;
  const visibleHeight = viewportHeight - paddingTop - paddingBottom;

  const messageTop =
    messageEl.getBoundingClientRect().top - scrollContainer.getBoundingClientRect().top + scrollContainer.scrollTop;
  const messageHeight = messageEl.offsetHeight;

  let targetScrollTop = messageTop - paddingTop;

  if (messageHeight <= visibleHeight) {
    const messageBottom = messageTop + messageHeight;
    const minScrollToRevealAll = messageBottom + paddingBottom - viewportHeight;
    targetScrollTop = Math.min(targetScrollTop, Math.max(0, minScrollToRevealAll));
  }

  targetScrollTop = Math.max(0, Math.min(targetScrollTop, maxScroll));

  scrollContainer.scrollTo({ top: targetScrollTop, behavior });
}
